import moment from 'moment';

const formatDate = (dateToFormat: any, formatString: string): string => {
  return moment(dateToFormat).format(formatString);
};

export default formatDate;
